import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedService } from '../../../../Services/shared.service';
import { CartService } from '../../../../Services/cart.service';
import { Router, RouterModule } from '@angular/router';
import { filter, take } from 'rxjs';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { Cart } from '../../../../Services/Cart';
import { any } from '@tensorflow/tfjs';


@Component({
  selector: 'app-checkout',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.css'
})
export class CheckoutComponent {

  bookList: any[] = [];
  PREP_UserInfo: any;
  todayDate = new Date();

  selectedCountryId: number | null = null;
  countryStateData: any[] = [];
  countries: any[] = [];
  states: any[] = [];
  addressList: any[] = [];

  selectedAddressIndex: number = 0;
  // selectedAddress: any = null;

  addAddressForm: any = {};
  isNewBillingAddress: boolean = false;
  isChangeAddress: boolean = false;

  OrderNumber: any;
  confirm: boolean = false;

  cartItems: Cart[] = [];
  isPayNow: boolean = false;

  billingDetails: any = {
    grossAmount: 0,
    discountAmount: 0,
    gstAmount: 0,
    netAmount: 0,
    cartItem: [],
    billingAddress: null
  };
  constructor(
    private fb: FormBuilder,
    public _svc: SharedService,
    private router: Router,
    private _cart: CartService
  ) { }

  ngOnInit(): void {
    this._cart.cartItems().subscribe(items => {

      this.billingDetails = {
        grossAmount: this._cart.GrossAmount(),
        discountAmount: this._cart.DiscountAmount(),
        gstAmount: this._cart.GSTAmount(),
        netAmount: this._cart.NetAmount(),
        cartItems: items || [],
        billingAddress: null
      }
    });

    this.addAddressForm = this.fb.group({
      id: [null],
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern(/^[1-9][0-9]{9}$/)]],
      country: ['', Validators.required],
      state: [''],
      city: ['', Validators.required],
      pin_code: ['', [Validators.required, Validators.pattern(/^[1-9][0-9]{5}$/)]],
      address: ['', Validators.required]

    });

    setTimeout(() => {
      this.loadUserAddresses();
      this.LodecountryStateData();
    }, 1000)

    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;

      if (this.PREP_UserInfo) {
        this.addAddressForm.patchValue({
          email: this.PREP_UserInfo.emailId,

        });
      }
    });
  }


  addNewAddress(): void {

    if (this.addAddressForm.invalid) {
      this.addAddressForm.markAllAsTouched();
      const invalidControl = Object.keys(this.addAddressForm.controls).find(key =>
        this.addAddressForm.get(key)?.invalid
      );

      if (invalidControl) {
        const element = document.querySelector(`[formControlName="${invalidControl}"]`) as HTMLElement;
        if (element) {
          element.focus();
        }
      }
      return;
    }

    const formData = this.addAddressForm.value;
    const selectedCountry = this.countries.find(c => c.countryId == +formData.country);
    if (this.selectedCountryId === 1) {
      const selectedState = this.states.find(s => s.stateId == +formData.state);
      formData.state = selectedState ? selectedState.stateName : null
    }
    formData.country = selectedCountry ? selectedCountry.countryName : null;
    this._svc.POST(formData, API_End_Point.InsertBillingAddressGe).subscribe(
      (res: any) => {
        if (res?.result === 'success') {
          this._svc.Notification('success', 'Address added successfully');
          this.loadUserAddresses();
          this.addAddressForm.reset();
          this.addAddressForm.patchValue({
            email: this.PREP_UserInfo.emailId
          });
          this.isChangeAddress = true;
          this.isNewBillingAddress = false;
        }
      },
      (err) => {
        console.error('Error:', err);
      }
    );
  }

  editAddresh(id: number) {

    const address = this.addressList.find(ary => ary.id === id);
    if (address) {
      const selectedCountry = this.countries.find(c => c.countryName === address.countryName);

      if (selectedCountry.countryId == 1) {
        this.onCountryChange(selectedCountry.countryId);
        var selectedState = this.states.find(s => s.stateName === address.state)
        address.state = selectedState ? selectedState.stateId : null
      }
      this.addAddressForm.patchValue({
        ...address,
        country: selectedCountry ? selectedCountry.countryId : null,
        pin_code: address.pinCode.toString(),
        id: address.id,
      });
    }
  }


  resetform() {
    this.ngOnInit();
    this.isChangeAddress == false
  }

  LodecountryStateData(): void {
    this._svc.GET(`${API_End_Point.LodecountryStateData}`).subscribe((res: any) => {
      if (res?.result === 'success' && Array.isArray(res.data)) {
        this.countryStateData = res.data;
        console.log(this.countryStateData);


        this.countries = [
          ...new Map(
            res.data.map((item: any) => [item.CountryId, {
              countryId: item.CountryId,
              countryName: item.CountryName
            }])
          ).values()
        ];
      } else {
        this.countryStateData = [];
        this.countries = [];
      }
    });
  }


  // onCountryChange(countryId: string | null) {
  //
  //   if (!countryId) {
  //     this.states = [];
  //     return;
  //   }
  //   this.states = [
  //     ...new Map(
  //       this.countryStateData
  //         .filter((x: any) => x.CountryId == +countryId && x.StateId)
  //         .map((item: any) => [item.StateId, { stateId: item.StateId, stateName: item.StateName }])
  //     ).values()
  //   ];
  // }



  onCountryChange(countryId: string | null) {
    this.selectedCountryId = countryId ? +countryId : null;
    debugger
    if (this.selectedCountryId != 1) {
      this.states = [];
      this.addAddressForm.get('state')?.reset();
      return;
    }

    if (this.selectedCountryId === 1) {

      this.states = [
        ...new Map(
          this.countryStateData
            .filter((x: any) => x.CountryId == 1 && x.StateId)
            .map((item: any) => [item.StateId, { stateId: item.StateId, stateName: item.StateName }])
        ).values()
      ];
    } else {

      this.states = [];
    }
  }

  loadUserAddresses(): void {

    this._svc.GET(`${API_End_Point.GetBillingAddress}`).subscribe((res: any) => {
      if (res?.result === 'success' && res.data?.length) {
        this.addressList = res.data;
        // this.addressList = [];
        console.log(this.addressList)
        this.selectedAddressIndex = 0;
        this.selectAddress(this.selectedAddressIndex);
      } else {
        this.addressList = [];
        //this.billingDetails.billingAddress = null;
        this.selectedAddressIndex = -1;
      }
    });
  }

  selectAddress(index: number): void {

    this.selectedAddressIndex = index;
    if (this.addressList.length == 0) {

    }
    else {
      this.billingDetails.billingAddress = this.addressList[index];
      // this.isChangeAddress = false;
      // this.isNewBillingAddress = false;
    }

  }



  confirmOrder() {
    debugger
    if (this.billingDetails.billingAddress == null) {
      this._svc.Notification("error", 'Please add/select an address before proceeding to payment.');
      return;
    }

    const checkoutPayload = {
      ShippingAddressId: this.billingDetails.billingAddress.id,
      // username: this.billingDetails.billingAddress.username,
      //address: this.billingDetails.billingAddress.address,
      // pinCode: this.billingDetails.billingAddress.pinCode,
      // country: this.billingDetails.billingAddress.countryName,
      mobile: this.billingDetails.billingAddress.mobile,
      emailId: this.billingDetails.billingAddress.email,
      userId: this.billingDetails.billingAddress.userId,
      // city: this.billingDetails.billingAddress.city,
      // state: this.billingDetails.billingAddress.state,
      create_date: new Date(),
      total_Shipping_Amount: this.billingDetails.netAmount,
      total_Shipping_Charges: 0,
      shipping_FirstBook: 0,
      shipping_NextBook: 0,
      redirect_url: 'test',
      cancel_url: 'test',
      currency: 'INR',
      coupon1: 0,
      coupon2: 0,
      coupon3: 0,
      discountAmount: this.billingDetails.discountAmount,
      isCouponAvailed: true,
      orderType: 5,
      bookList: this.billingDetails.cartItems
    };
    console.log(JSON.stringify(checkoutPayload));
    this._svc.POST(checkoutPayload, API_End_Point.CheckoutWithoutLogin).subscribe({
      next: (checkoutRes) => {

        if (checkoutRes.result.toLowerCase() === 'success') {
          this.isPayNow = true;
          this.OrderNumber = checkoutRes.orderNumber;


        }
      }
    });
  }



  payNow() {
    debugger
    const razorpayPayload = {
      amount: this._cart.NetAmount_InPaise(),
      currency: 'INR',
      payment_capture: true,
      key: environment.SZF_Key,
      secret: environment.SZF_Secret,
      orderNumber: this.OrderNumber
    };
    this._svc.POST(razorpayPayload, API_End_Point.CreateOrder).subscribe({
      next: (res) => {
        if (res.result.toLowerCase() === 'success') {
          const options: any = {
            key: environment.SZF_Key,
            amount: this._cart.NetAmount_InPaise(),
            currency: 'INR',
            name: 'Silverzone Foundation',
            description: this.OrderNumber,
            order_id: res.data.orderId,
            receipt: res.data.receipt,
            image: '../assets/images/all-instructor/sm-logo.png',
            payment_capture: true,
            prefill: {
              name: this.billingDetails.billingAddress.username,
              email: this.billingDetails.billingAddress.email,
              contact: this.billingDetails.billingAddress.mobile
            },
            theme: { color: '#3399FF' },
            handler: (response: any) => {

              const verifyPayload = {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                razorpay_order_id: response.razorpay_order_id,
                orderNumber: this.OrderNumber,
                refrenceType: 1,
                amount: this.billingDetails.netAmount,
                shippingCharge: 0,
                amountPaise: this._cart.NetAmount_InPaise(),
                conversionRate: 0,
                key: environment.SZF_Key,
                secret: environment.SZF_Secret,
                couponId: 0,
                discountAmount: this.billingDetails.discountAmount,
                couponCode: "",
                otp: '',
                mobile: this.billingDetails.billingAddress.mobile,
                username: this.billingDetails.billingAddress.username
              };

              this._svc.POST(verifyPayload, API_End_Point.VerifyPayment).subscribe({

                next: (verifyRes) => {

                  if (verifyRes.result === 'success') {
                    this._svc.Notification('success', `Payment successful for ₹${this.billingDetails.netAmount.toFixed(2)}`);
                    this.router.navigateByUrl(`paymentsuccess?OrderId=${this.OrderNumber}&orderType=5`);
                    setTimeout(() => location.reload(), 100);
                  }
                }
              });
            },
            modal: {
              ondismiss: () => {

                this._svc.Notification('info', 'Payment cancelled.');
              }
            }
          };

          const rzp = new this._svc.nativeWindow.Razorpay(options);
          rzp.on('payment.failed', (response: any) => {
            const failPayload = {
              orderNumber: this.OrderNumber,
              RefrenceType: 1,
              Amount: this.billingDetails.NetAmount,
              RZ_Payment_id: response.error.metadata.payment_id,
              Payment_Status: response.error.description
            };
            this._svc.POST(failPayload, API_End_Point.UpdatePaymentFailed).subscribe();
            this._svc.Notification('error', 'Payment failed.');

          });

          rzp.open();
        }
      }
    });
  }

}